<template>
  <BaseSpinner
    :outer-cls="outerCls"
    :inner-cls="innerCls"
    :inner-style="innerStyle"
    :size="spinnerSize"
  >

    <template #circleAfter>
      <text
        v-if="indicator"
        :class="textCls"
        font-size="12"
        transform="rotate(90 26 26)"
      >
        <tspan
          x="50%"
          y="50%"
          dominant-baseline="middle"
          text-anchor="middle"
        >
          {{ progressText }}
        </tspan>
      </text>
    </template>
  </BaseSpinner>
</template>

<script lang="tsx">
  import { defineComponent } from 'vue'
  import { BeerCls } from '@xhs/yam-beer/core/ds/index.js'
  import businessTheme from '@xhs/yam-beer/theme/businessTheme'
  import BaseSpinner from './BaseSpinner.vue'
  import { loadingKeyframes, loadingCircleKeyframes } from './animation.js'

  const CircleLength = 2 * Math.PI * 24

  export default defineComponent({
    name: 'ProgressBaseSpinner',
    components: {
      BaseSpinner,
    },
    inject: {
      theme: {
        default: businessTheme,
      },
    },
    props: {
      progress: {
        type: [Number, String],
        default: 10,
      },
      indicator: {
        type: Boolean,
        default: true,
      },
      size: {
        type: Number,
        default: 10,
      },
    },
    computed: {
      spinnerSize(): number {
        if (this.size) {
          return this.size
        }
        if (this.indicator) {
          return 48
        }
        return 30
      },
      progressText(): string {
        if (this.progress) {
          if (typeof this.progress === 'number') {
            return `${this.progress} %`
          }
          return `${parseInt(this.progress, 10)}%`
        }
        return ''
      },
      textCls(): string {
        return BeerCls({
          fill: 'brand',
        }, {
          // @ts-ignore
          theme: this.theme,
        })
      },
      outerCls() {
        if (!this.indicator) {
          return BeerCls({
            animation: `${loadingKeyframes} 2s linear infinite`,
          })
        }
        return BeerCls({
          transform: 'rotate(-90deg)',
        })
      },
      innerStyle(): { strokeDashoffset?: number } {
        if (!this.indicator) {
          return {}
        }
        return {
          strokeDashoffset: CircleLength - (+this.progress / 100) * CircleLength,
        }
      },
      innerCls() {
        if (!this.indicator) {
          return BeerCls({
            strokeDashoffset: 240,
            strokeDasharray: 120,
            animation: `${loadingCircleKeyframes} 1.6s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite`,
          })
        }
        return BeerCls({
          strokeDasharray: CircleLength,
          transition: 'stroke-dashoffset .6s ease-in-out',
        })
      },
    },
  })

</script>
